import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { TextField } from '../Textfield/TextField.js';
import { Popper } from '../Popper/Popper.js';
import { Icon } from '../Icon/Icon.js';
var _excluded = ["popperPosition", "labelText", "value", "pickerDataProp", "onChange", "required", "error", "helperText", "sxPopper", "sxTextField"],
    _excluded2 = ["ref"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles = {
  paper: {
    padding: 0,
    fontFamily: 'Lato,Roboto,"Helvetica Neue",Arial,sans-serif'
  },
  popper: {
    zIndex: 'modal'
  },
  pickerInputLabel: {
    '& label': {
      '& focus': {
        color: 'primary.main',
        fontWeight: 700
      }
    },
    '& [class*="MuiInputBase-input"]': {
      outline: 0
    }
  }
};

var ColorPicker = function ColorPicker(_ref) {
  var popperPosition = _ref.popperPosition,
      labelText = _ref.labelText,
      value = _ref.value,
      pickerDataProp = _ref.pickerDataProp,
      onChange = _ref.onChange,
      required = _ref.required,
      error = _ref.error,
      helperText = _ref.helperText,
      sxPopper = _ref.sxPopper,
      sxTextField = _ref.sxTextField,
      passedPickerProps = _objectWithoutProperties(_ref, _excluded);

  var paper = styles.paper,
      popper = styles.popper,
      pickerInputLabel = styles.pickerInputLabel;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var inputRef = React__default.useRef(null);

  var pickerProps = _objectSpread({
    presetColors: [],
    disableAlpha: true,
    width: '200px',
    color: value,
    onChangeComplete: function onChangeComplete(data) {
      onChange(data.hex);
    }
  }, passedPickerProps);

  var handleClickAway = function handleClickAway() {
    setOpen(false);
  };

  var keyListeners = {
    escape: 'Escape',
    enter: 'Enter'
  };

  var handleKeyDown = function handleKeyDown(event) {
    var enter = keyListeners.enter,
        escape = keyListeners.escape;
    var key = event.key;

    if (key === enter) {
      setOpen(function (previousOpen) {
        return !previousOpen;
      });
    }

    if (key === escape) {
      setOpen(false);
    }
  };

  var menu = /*#__PURE__*/React__default.createElement(SketchPicker, pickerProps);
  var textFieldProps = {
    InputProps: {
      readOnly: true,
      endAdornment: /*#__PURE__*/React__default.createElement(Icon, {
        style: {
          color: value
        },
        icon: 'Lens'
      })
    },
    onClick: function onClick() {
      setOpen(function (previousOpen) {
        return !previousOpen;
      });
    },
    value: value,
    ref: inputRef,
    label: labelText,
    required: required,
    error: error,
    helperText: helperText,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event);
    }
  };

  var ref = textFieldProps.ref,
      restTextFieldProps = _objectWithoutProperties(textFieldProps, _excluded2);

  var trigger = /*#__PURE__*/React__default.createElement(TextField, _extends({
    sx: [pickerInputLabel, sxTextField],
    ref: ref
  }, restTextFieldProps, {
    "data-selector": pickerDataProp
  }));
  var popperProps = {
    handleClickAway: handleClickAway,
    menu: menu,
    sxPaper: paper,
    open: open,
    popperAnchorRef: inputRef,
    sx: [popper, sxPopper],
    popperPosition: popperPosition,
    trigger: trigger
  };
  return /*#__PURE__*/React__default.createElement(Popper, popperProps);
};

ColorPicker.defaultProps = {
  popperPosition: 'bottom-end'
};
export { ColorPicker };